export const POPTIRA_LOCALES = {
  'en-US': {
    'meta.title': 'Poptira — Practical GEO Consulting & Implementation',
    'brand.name': 'Poptira',
    'brand.tagline': 'Your GEO growth engine for AI-driven demand',
    'home.hero.title': 'Make your brand<br>the default answer in AI',

    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.upload': 'Knowledge Base',
    'nav.dashboard': 'Citation Tracker',
    'nav.cases': 'Case Studies',
    'nav.insights': 'GEO Resources',
    'nav.getStarted': 'Get Started',

    'home.hero.subtitle': 'Upload verified facts → Get cited by AI → Reach buyers before they click',
    'home.hero.note': 'Go live in 3 days. See citations climb within 7.',
    'home.hero.ctaPrimary': 'Build your free knowledge base ➔',
    'home.hero.ctaSecondary': 'Explore our services',
    'home.dashboard.title': 'Keyword rank tracker',
    'home.dashboard.live': 'Live',
    'home.dashboard.sample': 'Sample Poptira performance dashboard',

    'home.whyGeo.title': 'Why GEO matters now',
    'home.whyGeo.headline': 'AI-first discovery is here. Brands are fighting for visibility in AI answers.',
    'home.whyGeo.trend': 'The shift is permanent',
    'home.whyGeo.traffic': 'AI search traffic ↑',
    'home.whyGeo.crossover': 'Projected to surpass traditional search by 2028',
    'home.whyGeo.trendDesc': "Discovery is moving to AI. Wait too long and you miss up to 80% of tomorrow's demand.",
    'home.whyGeo.entry': 'Own the front door',
    'home.whyGeo.entryDesc': '70%+ of users already start with AI when they need answers.',
    'home.whyGeo.results': 'Better outcomes',
    'home.whyGeo.conversion': 'Higher conversion efficiency',
    'home.whyGeo.resultsDesc': 'Unlike SEO click-chasing, AI answers reach buyers who already trust the recommendation.',
    'home.whyGeo.winner': 'Winner-take-most',
    'home.whyGeo.winnerDesc': 'Most AI answers surface only 1–3 brands. Everyone else gets left out.',
    'home.whyGeo.cost': 'About 1/5 the cost',
    'home.whyGeo.acquisition': 'Acquisition upside',
    'home.whyGeo.costDesc': 'GEO often delivers leads at ~20% of SEM cost with stronger ROI.',
    'home.whyGeo.moat': 'A durable moat',
    'home.whyGeo.moatDesc': "First movers build mindshare that's hard for competitors to displace.",
    'home.whyGeo.audience': 'What buyers expect',
    'home.whyGeo.audienceDesc': '80% of Gen Z say they trust AI recommendations when making decisions.',
    'home.whyGeo.lift': 'Brand lift in AI',
    'home.whyGeo.sampleQ': "Who's the best in [category]?",
    'home.whyGeo.sampleA': 'AI: We recommend [Your Brand]',
    'home.whyGeo.liftDesc': 'Earn AI credibility. When models keep naming you, you become the default answer.',

    'home.compare.title': 'GEO beats traditional SEO on impact and upside',
    'home.compare.seo': 'Traditional SEO',
    'home.compare.geo': 'GEO (AI search optimization)',

    'home.whyPoptira.title': 'Why Poptira',
    'home.whyPoptira.subtitle': 'Your GEO growth engine for AI-driven demand',
    'home.whyPoptira.mission': 'We help you become the answer AI gives — so every relevant question points to you.',
    'home.whyPoptira.intro': "Poptira is a U.S. technology company specializing in software development, software-as-a-service (SaaS), and information technology solutions, with a global footprint.",
    'home.whyPoptira.dna': 'We combine a lightweight delivery model with AI-native execution so programs launch fast:',
    'home.whyPoptira.b1': 'Make your content easy for AI to understand, trust, and cite',
    'home.whyPoptira.b2': 'Show up in answers from ChatGPT, Claude, Gemini, Perplexity, Copilot, and more',
    'home.whyPoptira.b3': 'Turn regional demand into measurable leads and revenue',
    'home.whyPoptira.cta': 'With Poptira, own the first answer buyers hear in the AI search era.',
    'home.ecosystem': 'Partner ecosystem',
    'home.creatorNetwork': 'Creator network',
    'home.creatorDesc': 'Creators and independent accounts',
    'home.mediaPartners': 'Media partners',
    'home.mediaDesc': 'Trusted media and social platforms',

    'home.steps.title': '3 steps to get cited in AI answers',
    'home.steps.s1.title': 'Upload brand facts',
    'home.steps.s1.desc': 'Add specs, awards, QA reports, and customer proof in minutes.',
    'home.steps.s2.title': 'Preview in AI',
    'home.steps.s2.desc': 'Preview how ChatGPT, Claude, and Perplexity might cite you — in real time.',
    'home.steps.s3.title': 'Track citations',
    'home.steps.s3.desc': 'Daily mention count and rank updates — as clear as an ad dashboard.',
    'home.steps.cta': 'Build your knowledge base free',

    'home.services.title': 'Services & pricing',
    'home.services.subtitle': 'Three modules. One lightweight GEO system.',
    'home.services.coreTag': 'Core Module',
    'home.services.m1.title': '1. AI knowledge base setup',
    'home.services.m1.b1': 'Customer discovery: 1:1 sessions to clarify pain points and goals.',
    'home.services.m1.b2': 'Focused competitor scan: 3–5 core rivals and their AI footprint.',
    'home.services.m1.b3': 'Keyword strategy: 10–20 high-value prompt opportunities.',
    'home.services.m1.deliverable': 'Brand AI knowledge base (JSON + vector bundle)',
    'home.services.m2.title': '2. Authority & source building',
    'home.services.m2.b1': 'Content optimization: metadata, structured data, and answer-ready assets.',
    'home.services.m2.b2': 'Authority outreach: 5–10 high-trust industry citation channels.',
    'home.services.m2.b3': 'Playbook capture: reusable GEO tactics added to your resource library.',
    'home.services.m2.deliverable': 'Authority links and third-party endorsement list',
    'home.services.m3.title': '3. Citation tracking & reviews',
    'home.services.m3.b1': 'Performance dashboard: track rankings, mentions, and traffic impact.',
    'home.services.m3.b2': 'Monthly review: one-page executive summary every month.',
    'home.services.m3.b3': 'Iteration plan: next-step actions based on live AI output.',
    'home.services.m3.deliverable': 'Monthly AI citation performance brief',
    'home.services.deliverable': 'Deliverable',
    'home.services.hoverHint': 'Hover to preview',
    'home.services.earlyBird': '🚀 Early-bird offer',
    'home.services.earlyBirdDesc': 'First 10 consultations include a free baseline audit',
    'home.services.consult': 'Book a consult',

    'home.process.title': 'How we work',
    'home.aiRec.title': 'Get recommended inside AI answers',
    'home.aiRec.subtitle': 'Move from ten blue links to one trusted answer — with your brand in it.',
    'home.aiRec.howTitle': 'How we make it happen',

    'about.title': 'About Us',
    'about.whyUs': 'Why work with us',
    'about.card1.title': '① Win visibility without ad spend',
    'about.card1.desc': 'Skip paid auctions. Get your brand written into the answer itself.',
    'about.card2.title': '② More qualified leads',
    'about.card2.desc': "People ask because they're ready to buy — often 3–7x better than feed ads.",
    'about.card3.title': '③ Borrowed trust from AI',
    'about.card3.desc': 'Buyers trust AI recommendations. One strong setup compounds over time.',
    'about.card4.title': '④ Fast to launch',
    'about.card4.desc': 'Three pages of input. Live in 14 days. No content team required.',
    'about.card5.title': '● Intent mapping',
    'about.card5.desc': 'Our GEO prompt library covers 1,200+ high-intent long-tail opportunities.',
    'about.card6.title': '● Modular answer assets',
    'about.card6.desc': 'Break proof points into bite-size answers models can cite naturally.',
    'about.card7.title': '● Cross-platform signal boost',
    'about.card7.desc': 'Distribute across 18 platforms — including Reddit and LinkedIn — to reinforce recall.',
    'about.card8.title': '● Measure and iterate',
    'about.card8.desc': 'The Poptira dashboard tracks share of voice; most clients reach 65%+ on priority terms within 30 days.',
    'about.stats.years': '12 years',
    'about.stats.yearsDesc': 'in digital marketing',
    'about.stats.brands': '800+',
    'about.stats.brandsDesc': 'brands served',
    'about.stats.team': '600+',
    'about.stats.teamDesc': 'specialists on the team',

    'upload.title': 'Build your brand knowledge base',
    'upload.subtitle': 'Add verified brand facts, generate JSON-LD, and preview how AI may cite you',
    'upload.formTitle': 'Upload your knowledge base',
    'upload.brand': 'Brand name *',
    'upload.brandPh': 'e.g. Summit Brew Co.',
    'upload.usp': 'One-line value proposition *',
    'upload.uspPh': 'Small-batch craft beer delivered cold within 24 hours',
    'upload.proof': 'Proof & credentials (files) *',
    'upload.chooseFiles': 'Choose files',
    'upload.noFilesChosen': 'No file chosen',
    'upload.filesSelected': '{count} files selected',
    'upload.proofHint': 'QA reports, awards, patents, press coverage, and more',
    'upload.submit': 'Generate knowledge base',
    'upload.previewLabel': 'AI answer preview (demo)',
    'upload.previewEmpty': 'Fill out the form to preview how AI might cite you',
    'upload.previewTemplate': '{platform}: {brand} has been gaining attention for {usp}.',
    'upload.success': 'JSON-LD and vector ID ready. Download now — citation data appears in your dashboard within 24 hours.',
    'upload.advisor': 'Want a custom plan? Talk to an advisor ➔',

    'dashboard.title': 'AI citation dashboard',
    'dashboard.subtitle': 'Track mention rate and recommendation rank across ChatGPT, Claude, Gemini, Perplexity, and more',
    'dashboard.advisor': 'Questions about the data? Need a deeper audit? Talk to your advisor ➔',
    'dashboard.metric.fcdSuffix': ' turns',

    'consult.title': 'Talk to an expert',
    'consult.subtitle': "Tell us about your business — we'll follow up with a 1:1 GEO assessment",
    'consult.back': '← Back to self-service setup',
    'consult.step1': '1. Basic Info',
    'consult.step2': '2. Business Needs',
    'consult.step3': '3. Contact Info',
    'consult.company': 'Company name',
    'consult.industry': 'Industry',
    'consult.size': 'Company size',
    'consult.coreBusiness': 'Core product or service',
    'consult.market': 'Target market',
    'consult.goals': 'Primary GEO goal',
    'consult.tools': 'AI tools already in use',
    'consult.period': 'Preferred engagement length',
    'consult.contactName': 'Contact name',
    'consult.contactPhone': 'Phone number',
    'consult.contactEmail': 'Work email',
    'consult.notes': 'Additional notes',
    'consult.privacy': 'I agree my information will only be used for consultation and proposal delivery.',
    'consult.submit': 'Submit',
    'consult.successTitle': "You're all set!",
    'consult.successDesc': 'A GEO specialist will reach out within 24 hours. Watch your phone and inbox.',
    'consult.backHome': 'Back to Home',

    'cases.title': 'Customer stories',
    'cases.subtitle': 'See how brands are winning in AI search',
    'cases.overview': 'Project Overview',
    'cases.showMore': 'View more case studies',
    'cases.showLess': 'Show less',
    'cases.clients': "Clients we've worked with",

    'insights.title': 'GEO insights',
    'insights.hot': 'Trending',
    'insights.latest': 'Latest',
    'insights.subscribeTitle': 'Subscribe to the GEO Brief',
    'insights.subscribeDesc': "Five of the week's best GEO research and data reports — every Wednesday",
    'insights.emailPh': 'Email address',
    'insights.subscribeBtn': 'Subscribe free',
    'insights.subscribedTitle': "You're subscribed!",
    'insights.subscribedDesc': 'Thanks — your first GEO Brief arrives next Wednesday.',
    'insights.back': 'Back',
    'insights.news5.title': 'Cross-border GEO: make AI say your brand name in any market',
    'insights.news5.desc': 'A Middle East real estate case: multilingual knowledge base + regional citations reached TOP1 in English and Arabic ChatGPT answers within 30 days.',
    'insights.latest1.title': 'arXiv | Evaluating citation trust in LLM answers',
    'insights.latest2.title': 'Nature | Generative search and SMB brand visibility',
    'insights.latest3.title': 'OpenAI | LLM citation bias research brief',
    'insights.latest4.title': 'McKinsey | 2026 AI Index: the answer economy',
    'insights.latest5.title': 'Gartner | 70% of CMOs will invest in GEO by 2027',
    'insights.latest6.title': 'SEMrush | GEO vs SEO conversion benchmarks',
    'insights.latest7.title': 'Stanford | Generative search trust evaluation dataset released',
    'insights.latest8.title': 'EPA | How corporate sustainability data gets cited in AI answers',

    'blog.back': '← Back to insights',
    'blog.ctaConsult': 'Book a consult',
    'blog.ctaDashboard': 'View citation dashboard',
    'blog.ctaProduct': 'Generate knowledge base',
    'blog.ctaCases': 'Read customer stories',
    'blog.ctaAbout': 'About our process',

    'footer.desc': 'Practical GEO consulting for teams that want results without the enterprise overhead.',
    'footer.quickLinks': 'Quick links',
    'footer.contact': 'Contact',
    'footer.phone': '+1 7072772356',
    'footer.email': 'bd@poptira.com',
    'footer.copyright': '© 2026 Poptira LLC. All rights reserved.',

    'sidebar.chat': 'Chat with us',
    'sidebar.email': 'Email us',
    'sidebar.call': 'Call us',
    'sidebar.sales': 'Sales: +1 7072772356',
    'sidebar.hotline': 'Support: +1 7072772356',

    'alert.companyName': 'Please enter your company name',
    'alert.coreBusiness': 'Please describe your core business or product',
    'alert.contact': 'Please complete your contact details',
  },
} as const

export type LocaleKey = keyof typeof POPTIRA_LOCALES
